import type { propsInterface } from '~~/modules/design-system/sections/s-cottage-swiper.vue'
import type { schemaType as ruralityCottagesListSchemaType } from '~~/modules/api/rurality/v3/cottages/list/schema'
import type { attributesCottageType } from '~~/modules/api/strapi/vacaciones-landings/detail/schema'

export const useToSCottageSwiper = () => {
  const fromCottagesList = (
    ruralityCottagesList: ruralityCottagesListSchemaType,
    strapiCottageSection: attributesCottageType,
  ): propsInterface => {
    const mappedCottages: propsInterface['cottages'] =
      ruralityCottagesList.cottages.map(
        (item: ruralityCottagesListSchemaType['cottages'][0]) => {
          const cottages: propsInterface['cottages'][0] = {
            url: item.url,
            src: item.media.url,
            name: item.name,
            province: item.province.name,
            numComments: item.reviews.total,
            rate: item.reviews.average,
          }

          return cottages
        },
      )

    return {
      cottages: mappedCottages,
      cta: {
        text: strapiCottageSection?.cta_text,
        link: strapiCottageSection?.cta_link,
      },
    }
  }

  return {
    fromCottagesList,
  }
}
